// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table2_container__J1gdV {
  overflow-x: scroll;
  overflow-y: scroll;
  position: relative;
}

.table2_containerLoader__BbtAf {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.2);
}

.table2_container__J1gdV table {
  max-width: auto;
  max-height: 100%;
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border-spacing: 0;
  /* border:1px solid #00b894; */
  border: 1px solid #22835f;
  text-align: left;
}

.table2_body__3q2cV {
  overflow: auto;
}
.table2_header__EIvTk {
  text-align: center;
  color: white;
  font-weight: 600;
  font-size: 1.15em;
  display: table-header-group;
  background-color: #22835f;
}

.table2_header__EIvTk tr th {
  padding: 0.5em 1em;
  /* min-width: 240px; */
}

.table2_head__YCndv {
  padding: 0.4em 0;
  justify-content: space-between;
}

.table2_data__aomxa {
  padding: 0.2em 1em;
  /* width: 100vw; */
  font-weight: 500;
}

.table2_data__aomxa * {
  margin: 0;
}

.table2_actionButton__QqHKx {
  background: none;
  border: none;
}

.table2_rowHeader__objoS td {
  font-weight: 600;
}
.table2_rowHeader__objoS td * {
  margin: 0;
}

.table2_reportContainer__DHTCN {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border-spacing: 0;
  /* border:1px solid #00b894; */
  border: 1px solid #22835f;
}

.table2_reportHeader__Rlzm6 {
  width: 100%;
  color: white;
  font-weight: 600;
  font-size: 1em;
  display: table-header-group;
  background-color: #055437;
}
`, "",{"version":3,"sources":["webpack://./src/components/Table/table2.module.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,8BAA8B;EAC9B,yBAAyB;EAGzB,gBAAgB;AAFlB;;AAKA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,yBAAyB;AAC3B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap');\n\n.container {\n  overflow-x: scroll;\n  overflow-y: scroll;\n  position: relative;\n}\n\n.containerLoader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.container table {\n  max-width: auto;\n  max-height: 100%;\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: collapse;\n  border-spacing: 0;\n  /* border:1px solid #00b894; */\n  border: 1px solid #22835f;\n}\n.container table {\n  text-align: left;\n}\n\n.body {\n  overflow: auto;\n}\n.header {\n  text-align: center;\n  color: white;\n  font-weight: 600;\n  font-size: 1.15em;\n  display: table-header-group;\n  background-color: #22835f;\n}\n\n.header tr th {\n  padding: 0.5em 1em;\n  /* min-width: 240px; */\n}\n\n.head {\n  padding: 0.4em 0;\n  justify-content: space-between;\n}\n\n.data {\n  padding: 0.2em 1em;\n  /* width: 100vw; */\n  font-weight: 500;\n}\n\n.data * {\n  margin: 0;\n}\n\n.actionButton {\n  background: none;\n  border: none;\n}\n\n.rowHeader td {\n  font-weight: 600;\n}\n.rowHeader td * {\n  margin: 0;\n}\n\n.reportContainer {\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: collapse;\n  border-spacing: 0;\n  /* border:1px solid #00b894; */\n  border: 1px solid #22835f;\n}\n\n.reportHeader {\n  width: 100%;\n  color: white;\n  font-weight: 600;\n  font-size: 1em;\n  display: table-header-group;\n  background-color: #055437;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `table2_container__J1gdV`,
	"containerLoader": `table2_containerLoader__BbtAf`,
	"body": `table2_body__3q2cV`,
	"header": `table2_header__EIvTk`,
	"head": `table2_head__YCndv`,
	"data": `table2_data__aomxa`,
	"actionButton": `table2_actionButton__QqHKx`,
	"rowHeader": `table2_rowHeader__objoS`,
	"reportContainer": `table2_reportContainer__DHTCN`,
	"reportHeader": `table2_reportHeader__Rlzm6`
};
export default ___CSS_LOADER_EXPORT___;
